import { forwardRef } from 'react';

import MuiFormHelperText from '@mui/material/FormHelperText';
const FormHelperText = forwardRef((props, ref) => {
  return <MuiFormHelperText ref={ref} {...props} />;
});
FormHelperText.displayName = 'FormHelperText';
export default FormHelperText;
